import { BREAK_POINT } from '@/assets/js/constants';
import Swiper from 'swiper/dist/js/swiper.min.js';

const Index = function () {
  // セレクター要素
  const $el = {
    form: $('.p-order-form form'),
    planItem: $('.p-plan-list__item a'),
    notesTitle: $('.p-notes-list__title'),
  }

  // スライダー実行
  slider();


  //
  // イベント設定: ご注文に関しての注意事項 > 詳細内容の開閉
  // 
  $el.notesTitle.on('click', function (e) {
    e.preventDefault();

    // 表示状態クラスのつけ外し処理
    if (!$(this).closest('.p-notes-list__item').hasClass('p-notes-list__item--active')) {
      $(this).closest('.p-notes-list__item').addClass('p-notes-list__item--active');
    } else {
      $(this).closest('.p-notes-list__item').removeClass('p-notes-list__item--active');
    }
  });

  //
  $('.p-good-pricing-inner .c-btn-order--high').on('click', function (e) {
    let select = 'course_id_3';
    // 指定コースを選択状態に変更
    $('#' + select).prop('checked', true);
    //対応するフォームにis-showクラスを付与する
    $('.p-select_course').removeClass('is-show');
    $('dd#' + select).addClass('is-show');
    //対応しないフォームにdisabled属性を付与する
    let selectDOMs = $('.p-select_course select');
    selectDOMs.each((index, selectDOM) => {
      let id = $(selectDOM).attr('id');
      $(selectDOM).attr('disabled', true);
      if (id == select) {
        $(selectDOM).attr('disabled', false);
      }
    });
  });

  //
  // イベント設定: ご注文コースリスト > コースリスト選択
  // 
  $el.planItem.on('click', function (e) {
    e.preventDefault();

    // 指定要素がない場合は処理終了
    if ($(this).find('.c-btn-order').length < 1) {
      return;
    }

    // 選択コースの判定
    let select;

    if ($(this).find('.c-btn-order--low').length > 0) {
      select = 'course_id_1';
    } else if ($(this).find('.c-btn-order--middle').length > 0) {
      select = 'course_id_2';
    } else if ($(this).find('.c-btn-order--high').length > 0) {
      select = 'course_id_3';
    }

    // 想定していたコース名ではない場合は処理終了
    if (!select || $('#' + select).length < 1) {
      return;
    }

    // 指定コースを選択状態に変更
    $('#' + select).prop('checked', true);

    //対応するフォームにis-showクラスを付与する
    $('.p-select_course').removeClass('is-show');
    $('dd#' + select).addClass('is-show');
    //対応しないフォームにdisabled属性を付与する
    let selectDOMs = $('.p-select_course select');
    selectDOMs.each((index, selectDOM) => {
      let id = $(selectDOM).attr('id');
      $(selectDOM).attr('disabled', true);
      if (id == select) {
        $(selectDOM).attr('disabled', false);
      }
    });

    // スクロール先フォーム要素のクラス名に変更があった場合は処理終了
    if ($('.p-order-form-inner').length < 0) {
      return;
    }

    //スクロールする
    $('html, body').stop().animate({ scrollTop: $('.p-order-form-inner').offset().top }, 500, 'swing');
  });

  //注文の例のアコーディオン実行
  accordion();
  //コース選択
  selectCourse();
}

//
// スライダー設定: お客様の声 | use swiper v4.5
//
function slider() {
  new Swiper('.p-voice .swiper-container', {
    allowTouchMove: true,
    centeredSlides: true,
    loop: true,
    loopAdditionalSlides: 3,
    loopFillGroupWithBlank: true,
    // 旧バージョンの指定方法
    // nextButton: '.swiper-button-next',
    // prevButton: '.swiper-button-prev',
    // noSwiping: true,
    // noSwipingClass: 'swiper-slide',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerColumnFill: 'row',
    slidesPerView: 3,
    spaceBetween: 10,
    slidesPerGroup: 3, //一度にスライドさせる個数
    paginationClickable: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true, //この行を追記する
      type: 'bullets',
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + ('0' + (index + 2)).slice(-2) + '</span>';
      },
    },
    breakpoints: {
      [BREAK_POINT]: {
        slidesPerView: 'auto',
        spaceBetween: 50,
        slidesPerGroup: 1, //一度にスライドさせる個数 
        // noSwiping: true,
        // noSwipingClass: 'swiper-slide',
        pagination: {
          el: '.swiper-pagination',
          clickable: true, //この行を追記する
          type: 'bullets'
        },
      }
    }
  });
}

function accordion() {

  const accordions = document.querySelectorAll('.p-plan-list__item-example');

  accordions.forEach(accordion => {
    accordion.addEventListener('click', (e) => {
      const content = accordion.nextElementSibling;

      content.classList.toggle('active');

      if (content.classList.contains('active')) {
        content.style.display = 'block';
      } else {
        content.style.display = '';
      }

    });
  });
}

function selectCourse() {
  const els = $('input[name="course"]');

  els.each((index, element) => {
    element.addEventListener('click', () => {
      let select = $(element).attr('id');

      //対応するフォームにis-showクラスを付与する
      $('.p-select_course').removeClass('is-show');
      $('dd#' + select).addClass('is-show');
      //対応しないフォームにdisabled属性を付与する
      let selectDOMs = $('.p-select_course select');
      selectDOMs.each((index, selectDOM) => {
        let id = $(selectDOM).attr('id');
        $(selectDOM).attr('disabled', true);
        if (id == select) {
          $(selectDOM).attr('disabled', false);
        }
      });

    });
  });

}

export default Index;